<template>
  <div class="community-selector-overlay" @click="handleOverlayClick">
    <div class="community-selector-modal" @click.stop>
      <div class="modal-header">
        <h3>Welcome to Protopia</h3>
        <md-button class="md-icon-button close-btn" v-if="closable" @click="close">
          <md-icon>close</md-icon>
        </md-button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="community-select" class="input-label">Select your community:</label>
          <md-field>
            <md-select v-model="selectedCommunity" name="community-select" id="community-select" placeholder="Choose a community">
              <md-option v-for="community in communities" :key="community.id" :value="community.id">
                {{ community.name }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="form-actions">
          <md-button class="md-raised md-primary save-btn" :disabled="!selectedCommunity" @click="saveCommunity">
            SAVE COMMUNITY
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/services/API';

export default {
  name: 'CommunitySelector',
  props: {
    closable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedCommunity: null,
      communities: [],
      loading: true
    };
  },
  async created() {
    await this.fetchCommunities();
    this.$root.$on('community-list-updated', this.updateCommunitiesList);
    this.$root.$on('community-name-changed', this.updateSingleCommunityName);
  },
  
  beforeDestroy() {
    this.$root.$off('community-list-updated', this.updateCommunitiesList);
    this.$root.$off('community-name-changed', this.updateSingleCommunityName);
  },
  methods: {
    close() {
      this.$emit('close');
    },
    handleOverlayClick() {
      if (this.closable) {
        this.close();
      }
    },
    async fetchCommunities() {
      this.loading = true;
      const user = JSON.parse(localStorage.getItem('authUser'));
      if (!user) {
        this.$router.push('/login');
        return;
      }

      try {
        const api = new API();
        if (api.headers && api.headers.headers) delete api.headers.headers['x-tenant-id'];
        
        const response = await api.get('tenants');
        if (response.data && response.data.data) {
          const allTenants = response.data.data
            .map(t => ({ id: t.communityId, name: t.communityName }))
            .sort((a, b) => a.name.localeCompare(b.name));

          const role = (user.role && user.role.toLowerCase()) || '';
          this.communities = role === 'superadmin'
            ? allTenants
            : allTenants.filter(t => user.communities && user.communities.includes(t.id));
          
          this.applyCachedNames();
        }
      } catch (error) {
        console.error("Error fetching communities", error);
      } finally {
        this.loading = false;
      }
    },
    
    applyCachedNames() {
      try {
        const cache = JSON.parse(localStorage.getItem('community_names_cache') || '{}');
        this.communities.forEach((c, i) => {
          if (cache[c.id]) this.communities[i].name = cache[c.id];
        });
      } catch (e) {
        console.error('Error applying cached names:', e);
      }
    },
    updateCommunitiesList(updatedList) {
      if (!updatedList || !updatedList.length) return;
      const user = JSON.parse(localStorage.getItem('authUser'));
      if (!user) return;
      
      const role = (user.role && user.role.toLowerCase()) || '';
      const filtered = role === 'superadmin' 
        ? updatedList 
        : updatedList.filter(c => user.communities && user.communities.includes(c._id));
      
      this.communities = filtered.map(c => ({ id: c._id, name: c.name }));
    },
    updateSingleCommunityName({ communityId, newName }) {
      const index = this.communities.findIndex(c => c.id === communityId);
      if (index !== -1) {
        this.$set(this.communities, index, { ...this.communities[index], name: newName });
      }
    },
    saveCommunity() {
      if (this.selectedCommunity) {
        const community = this.communities.find(c => c.id === this.selectedCommunity);
        localStorage.setItem('community_id', this.selectedCommunity);
        if (community) {
          localStorage.setItem('community_name', community.name);
        }
        this.$emit('saved');
      }
    }
  }
};
</script>

<style scoped>
.community-selector-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.community-selector-modal {
  background-color: white;
  padding: 3rem;
  border-radius: 4px;
  width: 500px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  text-align: center;
  position: relative;
  z-index: 100000;
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
}

.modal-header h3 {
  margin-top: 0;
  margin-bottom: 2rem;
  font-weight: 500;
  font-size: 1.2rem;
  color: #333;
}

.form-group {
  margin-bottom: 2rem;
  text-align: left;
}

.input-label {
  font-size: 1.3rem;
  color: #333;
  font-weight: 600;
  margin-bottom: 1rem;
  display: block;
}

.form-actions {
  display: flex;
  justify-content: center;
}

.save-btn {
  width: 100%;
  height: 45px;
  font-size: 1.1rem;
}

</style>

<style>
.md-menu-content.md-select-menu {
  z-index: 100001 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CommunitySelector.vue